import React from "react";
import Layout from "../../../components/layouts/Layout";
import { useTranslation } from "react-i18next";
import CategoriesSection from "../../../components/store/reusable/category/CategoriesSection";
import {  useSearchParams } from "react-router-dom";
import { useStoretickets } from "../../../hooks/store/tickets.store";
import { TicketStatus } from "../../../types/enum/TicketStatus";
import LoadingErrorState from "../../../components/ui/LoadingErrorState";
import EmptyData from "../../../components/ui/EmptyData";
import TicketsListWrapper from "../../../components/store/tickets/TicketsListWrapper";
import Pagination from "../../../components/ui/Pagination";

export default function TicketsListPage() {
         const {t} = useTranslation();
        const [searchParams,setSearchParams] = useSearchParams();
        const pageQuery = Number(searchParams.get('page')) || 1;
        const category = (searchParams.get("category")) ||"";

        const {data, isLoading , isError} = useStoretickets({page:pageQuery, status:category});
        console.log(data)
    
        const handlePagination = (page: number) => {
            const newParams = new URLSearchParams(searchParams);
            newParams.set('page', page.toString());
            setSearchParams(newParams);
        };
  const categories = [
            { id: TicketStatus.IN_PROGRESS, name: t(TicketStatus.IN_PROGRESS) },
            { id: TicketStatus.PENDING, name: t(TicketStatus.PENDING) },
            { id: TicketStatus.REJECTED, name: t(TicketStatus.REJECTED) },
            { id: TicketStatus.CLOSED, name: t(TicketStatus.CLOSED) },
          ];
  return (
    <Layout headline="" title={t("owner_sidebar.tickets")}>
        <CategoriesSection
        selectedCategory={category?category:""}
        categories={categories}
        buttonAddLinkPath={""}
        buttonLinkPath={"/store/add-ticket"}
        buttonLabel='add_new_ticket'
        showAdd={false}
        notShowAddButton={false}
        />
        <LoadingErrorState isError={isError} isLoading={isLoading}/>
        {data && (data.data.length===0 
        ? <EmptyData/> 
        :
        <>
          <TicketsListWrapper tickets={data.data}/>
           <Pagination
           currentPage={pageQuery}
          totalPages={data.totalPages||0}
          handlePagination={handlePagination}
          />
        </>
        )}

    </Layout>
  );
}
